<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M5.21531 17.8237H4.9987C4.21302 17.8237 3.82019 17.8237 3.57611 17.5796C3.33203 17.3355 3.33203 16.9427 3.33203 16.157V15.2303C3.33203 14.7983 3.33203 14.5823 3.44301 14.3893C3.554 14.1963 3.72142 14.099 4.05628 13.9043C6.26084 12.622 9.39162 11.9003 11.4813 13.1466C11.6216 13.2303 11.7479 13.3314 11.8558 13.4526C12.3209 13.975 12.287 14.7634 11.751 15.2313C11.6378 15.33 11.5172 15.405 11.3957 15.431C11.4955 15.4194 11.5912 15.4062 11.6825 15.3916C12.442 15.2704 13.0795 14.8646 13.6632 14.4237L15.1692 13.2861C15.7001 12.885 16.4881 12.8849 17.0191 13.2858C17.4972 13.6468 17.6434 14.2412 17.3411 14.7256C16.9887 15.2906 16.4921 16.0133 16.0153 16.4549C15.5378 16.8972 14.8269 17.292 14.2466 17.5721C13.6037 17.8824 12.8935 18.0612 12.1711 18.1782C10.706 18.4153 9.1792 18.3791 7.72897 18.0803C6.90914 17.9114 6.05769 17.8237 5.21531 17.8237Z"
      fill="currentColor"
    />
    <path
      d="M5.48609 2.15796C5.18044 2.4636 5.06616 2.88589 5.02344 3.54464C6.03872 3.5311 6.85922 2.7106 6.87276 1.69531C6.21401 1.73804 5.79173 1.85231 5.48609 2.15796Z"
      fill="currentColor"
    />
    <path
      d="M14.5117 2.15796C14.206 1.85231 13.7837 1.73804 13.125 1.69531C13.1385 2.7106 13.959 3.5311 14.9743 3.54464C14.9316 2.88589 14.8173 2.4636 14.5117 2.15796Z"
      fill="currentColor"
    />
    <path
      d="M14.5117 7.84761C14.206 8.15326 13.7837 8.26754 13.125 8.31026C13.1386 7.29497 13.959 6.47448 14.9743 6.46094C14.9316 7.11969 14.8173 7.54197 14.5117 7.84761Z"
      fill="currentColor"
    />
    <path
      d="M5.48609 7.84761C5.79173 8.15326 6.21401 8.26754 6.87276 8.31026C6.85922 7.29498 6.03872 6.47448 5.02344 6.46094C5.06616 7.11969 5.18044 7.54197 5.48609 7.84761Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 4.79297C6.72589 4.79297 8.125 3.39386 8.125 1.66797H11.875C11.875 3.39386 13.2741 4.79297 15 4.79297V5.20964C13.2741 5.20964 11.875 6.60874 11.875 8.33463H8.125C8.125 6.60874 6.72589 5.20964 5 5.20964V4.79297ZM10 5.83463C10.4602 5.83463 10.8333 5.46153 10.8333 5.0013C10.8333 4.54107 10.4602 4.16797 10 4.16797C9.53975 4.16797 9.16667 4.54107 9.16667 5.0013C9.16667 5.46153 9.53975 5.83463 10 5.83463Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'HighNetworthIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>